export default "__VITE_ASSET__Baf1b3wn__"